import * as React from 'react';

import { useAutoGenerateMockData } from 'src/containers/ProjectResourceSuggestionsDialog/hooks/useAutoGenerateMockData';
import { useAutoGenerateModel } from 'src/containers/ProjectResourceSuggestionsDialog/hooks/useAutoGenerateModel';

/**
 * Runs the create-project auto-generate flow. The two hooks each cost ~650ms of
 * render time on a large model (selectors + `isEqual` deep-compares), yet only
 * do real work when there is pending auto-generate work. Mounting this only
 * while something is pending keeps that cost out of the normal edit path — it
 * was previously paid on every model change via `ProjectDiagramView`.
 */
export const ProjectAutoGenerateRunner: React.VFC = () => {
  useAutoGenerateModel();
  useAutoGenerateMockData();
  return null;
};
